<template>
  <footer id="footer" class="section bg-dark text-white">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 text-center text-lg-start wow fadeInUp" style="visibility: visible; animation-name: none;">
          <p class="mb-2 mb-lg-0">Copyright © 2022 <a class="fw-600" href="#">Theodore Imonigie</a>. All Rights Reserved.</p>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'footer-component'
}
</script>